import { Pipe, PipeTransform } from '@angular/core';
import memoize from '@github/memoize/decorator';
import { Currency } from '..';

@Pipe({ name: 'objectValues' })
export class ObjectValuesPipe implements PipeTransform {
  @memoize()
  public transform<T>(
    value: { [id: string]: T } | { [id: string]: T },
    ...args: (string | number | boolean | Currency)[]
  ): T[] {
    return Object.values(value);
  }
}
